import React from 'react';
import capitalize from 'lodash/capitalize';
import { Schema } from '@cp/ds/src/components/schema';
import { CatalogItemType } from '@common/model/catalog/item/type';
import { usePathGenerator } from '@cp/entities/clientWebRoutes';
import { coreCareerApi } from '@cp/entities/career';
import { DeclinationMnemonic } from '@common/model/resource/declinationMnemonic';
import { ClientWebPage } from '@common/model/meta/clientWebPage';
import { useDeclination } from '@cp/shared/declination';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { getSiteNavigationElementsSchema } from 'src/shared/schema';

export interface CatalogListLinksSchemaProps {
  items: CatalogItemViewModel[] | undefined;
}

export const CatalogListLinksSchema: React.FC<CatalogListLinksSchemaProps> = ({ items }) => {
  const { data: careerDictionary } = coreCareerApi.endpoints.getCareers.useQuery();
  const declination = useDeclination();
  const generateAppPath = usePathGenerator();

  const schema = React.useMemo(
    () =>
      items &&
      careerDictionary &&
      getSiteNavigationElementsSchema(
        items.map(({ type, id, translation, careerId, clientProfile }) => ({
          name:
            type === CatalogItemType.Resume && clientProfile
              ? `${capitalize(careerDictionary[careerId]?.translation.nameSingle ?? '')}. ${clientProfile.name}, ${
                  clientProfile.age
                } ${declination(clientProfile.age as number, DeclinationMnemonic.Year)}`
              : String(translation?.title),
          url: generateAppPath({ page: ClientWebPage.CatalogItem, pageProps: { catalogType: type, careerId }, pathParams: { id } }),
        })),
      ),
    [careerDictionary, declination, generateAppPath, items],
  );

  if (!schema) {
    return null;
  }

  return <Schema schema={schema} />;
};
